import { Component, Input, OnInit } from '@angular/core';
import { Subscription, SubscriptionLicense } from '../../../shared/models/plans';
import * as planUtils from '../../../shared/plan/planUtils';

@Component({
  selector: 'cc-current-subscription-info',
  templateUrl: './current-subscription-info.component.html',
  styleUrls: ['./current-subscription-info.component.scss']
})
export class CurrentSubscriptionInfoComponent implements OnInit {
  @Input() private currentSubscription: Subscription;
  public subscriptionExpired = false;
  public remainingTime = '';
  public firstPlan: SubscriptionLicense;
  public trial = false;

  constructor() {}

  ngOnInit() {
    this.subscriptionExpired = planUtils.subscriptionExpired(this.currentSubscription);
    this.remainingTime = planUtils.formatPlanRemainingTime(this.currentSubscription);
    this.firstPlan = this.currentSubscription.licenses[0];
    this.trial = this.currentSubscription.status === 'TRIAL';
  }
}
